import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PropTypes from "prop-types";
import { useTranslation, withTranslation } from "react-i18next";

// Parainage Redux States
import {
  GET_PARAINAGES,
  ADD_NEW_PARAINAGE,
  UPDATE_PARAINAGE,
} from "./actionType";

import {
  parainageApiResponseSuccess,
  parainageApiResponseError,

  addParainageFail,
  addParainageSuccess,
  updateParainageSuccess,
  updateParainageFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getParainages as getParainagesApi,
  addNewParainage,
  updateParainage,
} from "../../helpers/fakebackend_helper";

function* getParainages() {
  try {
    const response = yield call(getParainagesApi);
    yield put(parainageApiResponseSuccess(GET_PARAINAGES, response));
  } catch (error) {
    yield put(parainageApiResponseError(GET_PARAINAGES, error));
  }
}

function* onUpdateParainage({ payload: parainage}) {
  console.log(parainage);
  try {
    const response = yield call(updateParainage, parainage);
    console.log(response);
    yield put(updateParainageSuccess(response));
  } catch (error) {
    console.log(error);
    yield put(updateParainageFail(error));
  }
}


function* onAddNewParainage({ payload: parainage }) {
  try {
    console.log(parainage);
    const response = yield call(addNewParainage, parainage);
    yield put(addParainageSuccess(response));
  } catch (error) {
    yield put(addParainageFail(error));
  }
}

export function* watchGetParainages() {
  yield takeEvery(GET_PARAINAGES, getParainages);
}


export function* watchUpdateParainage() {
  yield takeEvery(UPDATE_PARAINAGE, onUpdateParainage);
}

export function* watchAddNewParainage() {
  yield takeEvery(ADD_NEW_PARAINAGE, onAddNewParainage);
}

function* parainageSaga() {
  yield all([
    fork(watchGetParainages),
    fork(watchUpdateParainage),
    fork(watchAddNewParainage),
  ]);
}

export default parainageSaga;
